import React from 'react';
import propTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import * as Next from '@alifd/next';
import Tinymce from '@alife/super-text';
import fetchJsonp from 'fetch-jsonp';
import * as tarot from '@alife/tarot';
import ctoken from '@alife/puck-csrftoken';
import * as redux from 'redux';
import * as dva from 'dva';
import dvaImmer from 'dva-immer';
import moment from 'moment';

import MessageTip from './components/message-tip';
import Image from './components/image';
import log from './common/log';
import puckParameter from './common/puck-middleware';
import errLog from './common/retcode-log';
import Utils from './common/utils';
import I18N from './common/i18n';
import * as webIO from './common/web-io';
import * as requestHelper from './common/request';
import CardMap from './common/card-map';
import * as IMSDK from '@ali/icbu-im-sdk';

import { default as Logger } from './common/logger/log';
import { default as track } from './common/logger/track';

React.PropTypes = propTypes;
Next.Feedback = {
  toast: MessageTip
};
if (!window.IcbuIM) {
  window.IcbuIM = {};
}
const IcbuIM = window.IcbuIM;
IcbuIM['prop-types'] = propTypes;
IcbuIM.classnames = classNames;
IcbuIM['fetch-jsonp'] = fetchJsonp;
IcbuIM.redux = redux;
IcbuIM['dva-immer'] = dvaImmer;
IcbuIM['@alife/bc-i18n'] = I18N;
IcbuIM.dva1 = dva;
IcbuIM.React16 = React;
IcbuIM.propTypes = propTypes;
IcbuIM.ReactDOM16 = ReactDOM;
IcbuIM.Next1 = Next;
IcbuIM.TinymceOnReact16 = Tinymce;
IcbuIM.TarotOnReact16 = tarot;
IcbuIM.moment = moment;
//升级过程中发现@alife/linx-react加载的微应用很多存在bug，导致升级react16后依赖全局React变量，由于出现的地方很多，为了避免回归遗漏导致问题，这里统一fix
if (!window.React) {
  window.React = React;
}

window.Next = Next;
IcbuIM.react = React;
IcbuIM.React = React;
IcbuIM.propTypes = propTypes;
IcbuIM.ReactDOM = ReactDOM;
IcbuIM['react-dom'] = ReactDOM;
IcbuIM.Next = Next;
IcbuIM.Tinymce = Tinymce;
IcbuIM['@alife/next'] = Next;
IcbuIM['@alife/tarot'] = tarot;
IcbuIM['@alife/super-text'] = Tinymce;
IcbuIM.dva = dva;

IcbuIM.lib = {};
IcbuIM.lib.MessageTip = MessageTip;
IcbuIM.lib.Image = Image;
IcbuIM.lib.log = log;
IcbuIM.lib.ctoken = ctoken;
IcbuIM.lib.puckParameter = puckParameter;
IcbuIM.lib.errLog = errLog;
IcbuIM.lib.Utils = Utils;
IcbuIM.lib.I18N = I18N;
IcbuIM.lib.webIO = webIO;
IcbuIM.lib.requestHelper = requestHelper;
IcbuIM.lib.CardMap = CardMap;

IcbuIM.lib.Logger = Logger;
IcbuIM.lib.track = track;
IcbuIM.IMBaaSSDK = IMSDK;

for (const key in IcbuIM) {
  exports[key] = IcbuIM[key];
}

export default IcbuIM;
